/* eslint-disable react/jsx-no-literals */
import React from 'react';
import { NodeGroup, NodeRect, NodeText } from '@security/system-overview/GraphNodeParts';
export const ObjectNode = ({ cfg }) => {
    var _a, _b;
    const { label } = cfg !== null && cfg !== void 0 ? cfg : {};
    const height = Array.isArray(cfg.size) ? cfg.size[1] : (_a = cfg.size) !== null && _a !== void 0 ? _a : 30;
    const width = Array.isArray(cfg.size) ? cfg.size[0] : (_b = cfg.size) !== null && _b !== void 0 ? _b : 30;
    return (React.createElement(NodeGroup, { capture: true, draggable: true },
        React.createElement(NodeRect, { draggable: true, keyshape: true, style: {
                flexDirection: 'row',
                height: height,
                padding: 10,
                position: 'center',
                width: width
            } },
            React.createElement(NodeRect, { draggable: true, style: {
                    cursor: 'pointer',
                    fill: '#FFFFFF',
                    flexDirection: 'row',
                    justifyContent: 'center',
                    radius: 2,
                    stroke: '#1B96FF',
                    width: 'auto'
                } },
                React.createElement(NodeRect, { draggable: true, style: {
                        fill: '#1B96FF',
                        height: 'auto',
                        width: 4
                    } }),
                React.createElement(NodeRect, { draggable: true, style: {
                        padding: [8, 6]
                    } },
                    React.createElement(NodeText, { draggable: true, style: {
                            cursor: 'pointer',
                            fill: 'rgba(0,0,0,0.88)',
                            fontSize: 21
                        } }, label))))));
};
